import { computed, observable } from 'mobx';
import { StorageModel } from '../storage/model';
import { EnvModel } from '../env/model';
import { RouterModel } from '../router/model';
import jwt_decode from 'jwt-decode';
import {JWTToken} from '../../types/auth';
import {User} from '../../types/user';

export class AuthModel {


  constructor(
    private env: EnvModel,
    private storage: StorageModel,
    private router: RouterModel,
  ) {
    this.loadInitial();
  }

  loadInitial = () => {
    if (!this.env.isServer && document.referrer) {
      const matches = /(?:https?:\/\/)?([^/]+).*$/.exec(document.referrer);

      this.referrerUrl = matches.length >= 2 ? matches[1] : '';
    }
  };

  @observable
  mustReAuth: boolean = false;

  @observable
  hasFetched: boolean = false;

  @observable
  hasBetaInvite: boolean = false;

  @observable
  referrerUrl: string = null;

  @computed
  get isPermitted(): boolean {
    return true; // Allow everyone to sign up
  }

  @computed
  get token(): string {
    return this.storage.getItem(TOKEN);
  }

  @computed
  get tokenDecoded(): JWTToken {
    return this.token ? jwt_decode(this.token) as JWTToken : null;
  }

  @computed
  get user(): User {
    return this.storage.getItem(USER) as User;
  }

  @computed
  get youtubeLoginURL(): string {
    return this.youtubeRedirect(this.router.location.pathname);
  }

  youtubeRedirect = (redirect: string) => {
    return this.env.authUri
        + '/auth/youtube/redirect?skip_waiting=true&redirect_uri='
        + encodeURIComponent(redirect)
        + (!this.referrerUrl ? '' : ('&referrer_url=' + encodeURIComponent(this.referrerUrl)));
  }

  @computed
  get youtubeChannelLoginURL(): string {
    return this.youtubeChannelRedirect(this.router.location.pathname);
  }

  youtubeChannelRedirect = (redirect: string) => {
    return this.env.authUri
      + '/auth/youtube/channel/redirect?redirect_uri='
      + encodeURIComponent(redirect)
      + '&token=' + encodeURIComponent(this.token);
  };

  @computed
  get spotifyLoginURL(): string {
    return this.spotifyRedirect(this.router.location.pathname);
  }

  spotifyRedirect = (redirect: string) => {
    return this.env.authUri
        + '/auth/spotify/redirect?redirect_uri='
        + encodeURIComponent(redirect)
        + '&token=' + encodeURIComponent(this.token);
  }

  @computed
  get twitterLoginURL(): string {
    return this.twitterRedirect(this.router.location.pathname);
  }

  @computed
  get twitterLoginURLWithFollow(): string {
    return this.twitterRedirect(this.router.location.pathname) + '&follow_us=true';
  }

  twitterRedirect = (redirect: string) => {
    return this.env.authUri
        + '/auth/twitter/redirect?redirect_uri='
        + encodeURIComponent(redirect)
        + '&token=' + encodeURIComponent(this.token);
  };


  @computed
  get dropboxLoginURL(): string {
    return this.dropboxRedirect(this.router.location.pathname);
  }

  dropboxRedirect = (redirect: string) => {
    return this.env.authUri
        + '/auth/dropbox/redirect?redirect_uri='
        + encodeURIComponent(redirect)
        + '&token=' + encodeURIComponent(this.token);
  }

  @computed
  get facebookLoginURL(): string {
    return this.facebookRedirect(this.router.location.pathname);
  }

  facebookRedirect = (redirect: string) => {
    return this.env.authUri
        + '/auth/facebook/redirect?redirect_uri='
        + encodeURIComponent(redirect);
  }
}

export const USER = 'user';
export const TOKEN = 'token';